<template>
  <div v-if="this.isLoading" class="title-bar">
    <b-form>
      <br><br><br><br><br>
      <h5 style='color:white'>loading</h5>
      <br>
       <b-spinner style="color: rgb(109,122,82) !important"
        variant="warning"
      ></b-spinner>
    </b-form>
  </div>
  <div v-else class="main">
    <b-row style="margin:0">
      <b-col md="8" style="height:100vh;padding-left:0!important">
        <div class="login-picture">
          <div class="photography">
            <p>photography : tim mossholder</p>
          </div>
          <div class="language">
            <template>
              <!-- <b-dropdown left split text="language" class="language-dropdown" toggle-class="toggle-language" split-class="split-language" style="font-size: 12px;"> -->
              <b-dropdown left split text="language" 
                class="language-dropdown-white" 
                toggle-class="toggle-language-white" 
                split-class="split-language-white" 
                style="font-size: 12px;"
              >
                <template #button-content>
                  <img
                    :src="currentLanguageFlag"
                    style="width:28px; height:19px; border-radius:2px;"
                  >
                </template>

                <!-- Dropdown Items -->
                <b-dropdown-item @click="selectLanguage('en')">
                  <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                  English
                </b-dropdown-item>
                <b-dropdown-item  @click="selectLanguage('fr')">
                  <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                  Français (French)
                </b-dropdown-item>
                <b-dropdown-item  @click="selectLanguage('de')">
                  <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                  Deutsch (German)
                </b-dropdown-item>
                <b-dropdown-item  @click="selectLanguage('es')">
                  <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                  Español (Spanish)
                </b-dropdown-item>
                <b-dropdown-item  @click="selectLanguage('it')">
                  <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                  Italiano (Italian)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('nl')">
                  <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                  Nederlands (Dutch)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('pt')">
                  <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                  Português (Portuguese) 
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </div>
          <div class="login-overlay">
            <h1 class="main-title"><b><span style="color: rgb(195,147,130)">WYNE</span></b>LOVER</h1>
            <p class="main-subtitle">{{ translate("the open digital wine ecosystem") }}</p>
            <br>
          </div>
          <div class="social-media">
            <div style="width:30px; display:inline-block; margin-right:10px">
              <b-img
                fluid
                :src="require('@/assets/img/facebook-white.png')"
                v-on:click="gotoFacebook()"
              >
              </b-img>
            </div>
            <div style="width:30px; display:inline-block;margin-left:10px">
              <b-img
                fluid
                :src="require('@/assets/img/instagram-white.png')"
                v-on:click="gotoInstagram()"
              >
              </b-img>
            </div>
          </div>
          <div class="copyright">
            <p style="text-align:center"> {{ translate("funware for wine lovers developed and © copyrighted by N'JOY Information Technology") }}</p>
          </div>  
        </div>
      </b-col>
      <b-col md="4" style="border-left: 5px solid white">
        <b-row class="click-box w-cursor-click" v-on:click="onAboutUs()">
          <div class="home-picture">
            <div class="box-overlay">
              <p class="box-text">{{ translate("who we are, what we do") }}</p>
            </div>
          </div>
        </b-row>
        <b-row class="click-box w-cursor-click" v-on:click="onWyneCellar()">
          <div class="wynecellar-picture">
            <div class="box-overlay">
              <p class="box-text">{{ translate("for wine collectors") }}</p>
            </div>
          </div>
        </b-row>
        <b-row class="click-box w-cursor-click" v-on:click="onWyneTaster()">
          <div class="wynetaster-picture">
            <div class="box-overlay">
              <p class="box-text">{{ translate("for wine tasting events") }}</p>
            </div>
          </div>
        </b-row>        
        <b-row class="click-box w-cursor-click" v-on:click="onWyneMaker()">
          <div class="wynemaker-picture">
            <div class="box-overlay">
              <p class="box-text">{{ translate("for wine producers") }}</p>
            </div>
          </div>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import Cookies from 'js-cookie';

  import {wordlist,translate_word} from '../assets/js/translate.js';

  export default {
    name: 'Index',
    computed: {
      currentLanguage() {
        return this.$store.state.language
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      },
    },
    data() {
      return {
        language:'en',
        isLoading : true,
      }
    }, 
    mounted() {
      let local_debug = false

      let language = Cookies.get('wynelover.language')
      if (typeof language == "undefined") {
        language = "en"
        if (local_debug || this.debug) console.log("Login.mounted: cookie NOT found wynelover.language = ", language)
      } else {
        if (local_debug || this.debug) console.log("Login.mounted: cookie found wynelover.language = ", language)
      }
      this.selectLanguage(language)

      this.isLoading = false;
    },
    methods: { 
      onAboutUs() {
        this.$router.push({path:'/AboutUs'});
      },
      onWyneMaker() {
       window.open('http://www.wynemaker.com', '_blank');
      },
      onWyneCellar() {
       window.open('http://www.wynecellar.com', '_blank');
      },
      onWyneTaster() {
       window.open('http://www.wynetaster.com', '_blank');
      },
      gotoFacebook() {
        window.open("https://www.facebook.com/wynelover.eu", '_blank');
      },
      gotoInstagram() {
        window.open("https://www.instagram.com/wyne.lover/", '_blank');
      },
      async selectLanguage(language) {
        let local_debug = false
        if (local_debug || this.debug) console.log("Login.selectLanguage: START");
        this.language = language
        this.$store.commit('setLanguage',language)

        Cookies.set('wynelover.language', language, { expires: 365 });
        if (local_debug || this.debug) console.log("Login.selectLanguage: language set to ", language);

        if (local_debug || this.debug) console.log("Login.selectLanguage: STOP");
      }, 

      translate(string) {
        return translate_word(string, this.currentLanguage);
      },            
    },
  }
</script>

<style scoped>
.main {
  overflow-x: hidden;
  overflow-y: hidden;
}
.login-picture {
    height:100vh !important;
    width:100% !important;
    
    background-image: url("../assets/img/wynelover.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    position:absolute;
    display: flex;
    justify-content: center;
}
.home-picture {
    height:25vh !important;
    width:100% !important;
    
    background-image: url("../assets/img/home.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    position:absolute;
    display: flex;
    justify-content: center;
    border-bottom: 5px white solid;
}
.language {
  position: fixed;
  top: 5px;
  left: 5px;
  color: white;
}

.wynecellar-picture {
    height:25vh !important;
    width:100% !important;
    
    background-image: url("../assets/img/wynecellar.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    position:absolute;
    display: flex;
    justify-content: center;

    border-bottom: 5px white solid;
}

.wynetaster-picture {
    height:25vh !important;
    width:100% !important;
    
    background-image: url("../assets/img/wynetaster.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    position:absolute;
    display: flex;
    justify-content: center;
    border-bottom: 5px white solid;
}

.wynemaker-picture {
    height:25vh !important;
    width:100% !important;
    
    background-image: url("../assets/img/wynemaker.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    position:absolute;
    display: flex;
    justify-content: center;
}

.login-overlay {
  position: relative;
  top: 35vh;
}

.box-overlay {
  position:relative;
  top:45%;
}


.main-title {
  font-size: clamp(54px,5vw, 96px)!important;
  color:white !important;
  text-align:center;
  margin:0;
}

.main-subtitle {
font-size:clamp(14px,2vw, 24px)!important;
color:rgb(200,200,200);
text-align:center;
margin-top:-5px;
font-weight: bold;
}


.box-text {
font-size:clamp(14px,2vw, 24px)!important;
color:white;
text-align:center;
margin-top:-5px;
font-weight: bold;
}

.click-box {
  border-style: solid;
  border-width: 10px;
  border-color:white;
  height:25%;

  display: flex;
  justify-content: center;
  align-items: center;
}
.social-media {
  position: fixed;
  bottom: 55px;
  color: white;
}
.copyright {
  position: fixed;
  font-size:clamp(8px,1.5vw, 14px)!important;
  bottom: 0px;
  color: white;
}

.title-bar {
  text-align: center;
}

.w-cursor-click {
  cursor: pointer;
}



</style>
